import button from '../Button/styleOverrides';
import outlinedInput from '../OutlinedInput/styleOverrides';
import tableCell from '../TableCell/styleOverrides';
import tableHead from '../TableHead/styleOverrides';
import appBar from '../AppBar/styleOverrides';
import avatar from '../Avatar/styleOverrides';
import linearProgress from '../LinearProgress/stylesOverrides';
import chip from '../Chip/stylesOverrides';
import alert from '../Alert/styleOverrides';
import inputAdornment from '../InputAdornment/styleOverrides';
import inputBase from '../InputBase/styleOverrides';
import inputLabel from '../InputLabel/styleOverrides';
import select from '../Select/styleOverrides';
import step from '../Step/styleOverrides';
import stepConnector from '../StepConnector/styleOverrides';
import stepIcon from '../StepIcon/styleOverrides';
import stepLabel from '../StepLabel/styleOverrides';
import stepper from '../Stepper/styleOverrides';
import switch_ from '../Switch/styleOverrides';
import tab from '../Tab/styleOverrides';
import tabs from '../Tabs/styleOverrides';
import dialog from '../Dialog/styleOverrides';
import dialogTitle from '../DialogTitle/styleOverrides';
import dialogContent from '../DialogContent/styleOverrides';
import checkbox from '../Checkbox/styleOverrides';
import link from '../Link/styleOverrides';
import list from '../List/styleOverrides';
import textField from '../TextField/styleOverrides';
import toggleButtonGroup from '../ToggleButtonGroup/styleOverrides';
import treeItem from '../TreeItem/styleOverrides';
import backdrop from '../Backdrop/styleOverrides';
import autocomplete from '../Autocomplete/styleOverrides';
import radio from '../Radio/styleOverrides';
import formGroup from '../FormGroup/styleOverrides';
import formControlLabel from '../FormControlLabel/styleOverrides';
import iconButton from '../IconButton/styleOverrides';
import breadcrumbs from '../Breadcrumbs/styleOverrides';
import tableSortLabel from '../TableSortLabel/styleOverrides';

const styleOverrides = {
  button,
  outlinedInput,
  tableCell,
  tableHead,
  appBar,
  avatar,
  linearProgress,
  chip,
  formControlLabel,
  formGroup,
  alert,
  iconButton,
  inputAdornment,
  inputBase,
  inputLabel,
  select,
  step,
  stepConnector,
  stepIcon,
  stepLabel,
  stepper,
  ['switch']: switch_,
  tab,
  tabs,
  dialog,
  dialogTitle,
  dialogContent,
  checkbox,
  link,
  list,
  textField,
  toggleButtonGroup,
  treeItem,
  backdrop,
  autocomplete,
  radio,
  breadcrumbs,
  tableSortLabel,
};

export default styleOverrides;
